/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Consent_SensitiveInputs */

const en_us2_body_assessment_consent_sensitive = /** @type {(inputs: Body_Assessment_Consent_SensitiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos of your body, and the numbers taken from them, are sensitive personal data. You decide, and you can change your mind at any time.`)
};

const pt_br2_body_assessment_consent_sensitive = /** @type {(inputs: Body_Assessment_Consent_SensitiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos do seu corpo, e os números tirados delas, são dados pessoais sensíveis. Quem decide é você, e você pode mudar de ideia quando quiser.`)
};

const es_419_body_assessment_consent_sensitive = /** @type {(inputs: Body_Assessment_Consent_SensitiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las fotos de tu cuerpo, y los números que se obtienen de ellas, son datos personales sensibles. Tú decides, y puedes cambiar de opinión cuando quieras.`)
};

const pt_pt2_body_assessment_consent_sensitive = /** @type {(inputs: Body_Assessment_Consent_SensitiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As fotos do teu corpo, e os números tirados delas, são dados pessoais sensíveis. Quem decide és tu, e podes mudar de ideias quando quiseres.`)
};

const fr_fr2_body_assessment_consent_sensitive = /** @type {(inputs: Body_Assessment_Consent_SensitiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les photos de ton corps, et les chiffres qui en sont tirés, sont des données personnelles sensibles. C'est toi qui décides, et tu peux changer d'avis à tout moment.`)
};

const de_de2_body_assessment_consent_sensitive = /** @type {(inputs: Body_Assessment_Consent_SensitiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos deines Körpers und die daraus gewonnenen Zahlen sind sensible personenbezogene Daten. Du entscheidest, und du kannst es dir jederzeit anders überlegen.`)
};

const it_it2_body_assessment_consent_sensitive = /** @type {(inputs: Body_Assessment_Consent_SensitiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le foto del tuo corpo, e i numeri ricavati da esse, sono dati personali sensibili. Decidi tu, e puoi cambiare idea quando vuoi.`)
};

/**
* | output |
* | --- |
* | "Photos of your body, and the numbers taken from them, are sensitive personal data. You decide, and you can change your mind at any time." |
*
* @param {Body_Assessment_Consent_SensitiveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_consent_sensitive = /** @type {((inputs?: Body_Assessment_Consent_SensitiveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Consent_SensitiveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_consent_sensitive(inputs)
	if (locale === "es-419") return es_419_body_assessment_consent_sensitive(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_consent_sensitive(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_consent_sensitive(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_consent_sensitive(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_consent_sensitive(inputs)
	return en_us2_body_assessment_consent_sensitive(inputs)
});
export { body_assessment_consent_sensitive as "body-assessment.consent_sensitive" }